import { ApolloLink, Observable, ServerError } from "@apollo/client";
import * as Sentry from "@sentry/react";
import endpoints from "config/endpoints.js";

const isValidationError = (response) => response.errors.every((error) => error.message === "Validation Error");
const isAuthError = (error) => error.statusCode === 401 || error.statusCode === 403;

const handleServerError = (error) => {
  if (isAuthError(error)) {
    document.location.replace(endpoints.login);
  }

  return undefined;
};

const handleError = (error, operation) => {
  const { response } = error;

  if (ServerError.is(error)) return handleServerError(error);
  if (response && isValidationError(response)) return;

  Sentry.captureMessage(`GraphQL Error: ${operation.operationName}`, {
    extra: {
      errors: response?.errors.map(({ message }) => message),
      operationName: operation.operationName,
      variables: operation.variables,
    },
  });
};

export default function createErrorLink() {
  return new ApolloLink((operation, forward) => {
    return new Observable((observer) => {
      return forward(operation).subscribe({
        complete: () => observer.complete(),
        error: (error) => {
          handleError(error, operation);

          observer.error(error);
        },
        next: (result) => {
          observer.next(result);
        },
      });
    });
  });
}
